/* eslint-disable react/prop-types */
import React from 'react'
import { Redirect, Route } from 'react-router-dom'

import HomeLayout from 'Layouts/home'
import { useAuth } from 'Hooks'

function PrivateRoute({
  component: Component,
  layout: Layout = HomeLayout,
  ...rest
}) {
  const { authenticated } = useAuth()
  return (
    <Route
      {...rest}
      render={(props) => {
        if (authenticated) {
          return (
            <Layout>
              <Component {...props} />
            </Layout>
          )
        }
        return (
          <Redirect
            to={{ pathname: '/', state: {} }}
          />
        )
      }}
    />
  )
}

export default PrivateRoute
